import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faBan } from '@fortawesome/free-solid-svg-icons';

import { postTypeToString, registrationStateToString } from '../../../../../Utils/Converters';
import { USER, ORGANISER } from '../../../../../Data/Constants';

import './Registration.css';

function Registration(props) {
    const { type, userName, guestName, userEmail, guestEmail, steinCaption, paidAmount, remark, adminMessage, post, state } = props.registration;

    return (
        <Button color="primary" type="button" className="col-lg-4 col-md-6 mx-auto" onClick={props.onClick}>
            <span className="registration-title">{type === USER || type === ORGANISER ? userName : guestName}</span><br />
            {type === USER || type === ORGANISER ? userEmail : guestEmail}<br />
            Korsó: {steinCaption ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faBan} />}{' '}{steinCaption}<br />
            {/*Fizetve: {paidAmount} JMF<br /> */ /*todo: readd when payments are properly implemented */}
            {type === ORGANISER && <div>{postTypeToString(post)} ({registrationStateToString(state)})</div>}
            {remark ? <div>Megjegyzés: {remark.substring(0, 20)}{remark.length > 20 ? '...' : ''}</div> : null}
            {adminMessage ? <span>Üzenet: {adminMessage.substring(0, 20)}{adminMessage.length > 20 ? '...' : ''}</span> : null}
        </Button>
    );
}

export default Registration;